module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feishiApprove"
  }, [_c('el-card', {
    staticClass: "box-card fl",
    staticStyle: {
      "width": "40%",
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header fl"
  }, [_vm._v("飞书类型")])]), _vm._v(" "), _c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "inline": true,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入类型名称"
    },
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", $$v)
      },
      expression: "searchForm.name"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.basicsAuth.insertFeishu) ? _c('el-button', {
    staticClass: "fr",
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.AddMenuForm()
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.roleInfo,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "row-click": _vm.openDetails
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "类型",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "类型名称",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "width": "80",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.state == 0 ? '禁用' : '启用'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("\n                更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.basicsAuth.updateFeishu) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.EditRole(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.removeFeishu) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.DelRole(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "toolbar",
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'pages')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'pages')
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogStatus],
      "visible": _vm.dialogRoleEdit,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogRoleEdit = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('dialogRoleEdit', 'editRole')
      }
    }
  }, [_c('el-form', {
    ref: "editRole",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editRole,
      "label-width": "100px",
      "rules": _vm.editRoleRules
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "类型:",
      "prop": "value"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入类型(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.editRole.value),
      callback: function($$v) {
        _vm.$set(_vm.editRole, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRole.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "类型名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入类型(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.editRole.name),
      callback: function($$v) {
        _vm.$set(_vm.editRole, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRole.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "state"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.editRole.state),
      callback: function($$v) {
        _vm.$set(_vm.editRole, "state", $$v)
      },
      expression: "editRole.state"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createData('editRole')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateData('editRole')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRoleEdit = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogStatus],
      "visible": _vm.dialogRoleEditShu,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogRoleEditShu = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('dialogRoleEditShu', 'editRoleShu')
      }
    }
  }, [_c('el-form', {
    ref: "editRoleShu",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editRoleShu,
      "label-width": "100px",
      "rules": _vm.editRoleRules
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "编码:",
      "prop": "value"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入编码(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.editRoleShu.value),
      callback: function($$v) {
        _vm.$set(_vm.editRoleShu, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRoleShu.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "属性名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入属性名称(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.editRoleShu.name),
      callback: function($$v) {
        _vm.$set(_vm.editRoleShu, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRoleShu.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "state"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.editRoleShu.state),
      callback: function($$v) {
        _vm.$set(_vm.editRoleShu, "state", $$v)
      },
      expression: "editRoleShu.state"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createDataShu('editRoleShu')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateDataShu('editRoleShu')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRoleEditShu = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "55%"
    }
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header fl"
  }, [_vm._v("属性值")]), _vm._v(" "), (_vm.basicsAuth.insertFeishu) ? _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.AddMenuFormShu()
      }
    }
  }, [_vm._v("新增属性")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.feishuList,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "属性编码",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "属性名称",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "width": "150",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.state == 0 ? '禁用' : '启用'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("\n                更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.basicsAuth.updateFeishu) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.EditRoleShu(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.removeFeishu) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.DelRoleShu(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "toolbar",
    attrs: {
      "background": "",
      "current-page": _vm.pagesh.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pagesh.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pagesh.total
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'pagesh')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'pagesh')
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-45ae6da2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemSet/feishuApprove.vue
// module id = 1643
// module chunks = 0